var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _ellipse, _ellipse2, _path32, _line, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _ellipse3, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _line2, _path62, _path63, _path64, _path65, _line3, _path66, _path67, _path68, _ellipse4, _path69, _path70, _path71, _circle, _circle2, _circle3, _path72, _path73, _path74, _path75, _path76, _path77, _ellipse5, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _ellipse6, _ellipse7, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _polygon, _rect, _path148, _line4, _path149, _line5, _line6, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _polygon2, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _line7, _line8, _line9, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _ellipse8, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-14,.cls-15,.cls-18,.cls-20,.cls-21,.cls-22,.cls-23,.cls-27,.cls-29,.cls-4,.cls-6{fill:none;}.cls-2{fill:#eaf9f3;}.cls-3{clip-path:url(#clip-path);}.cls-4,.cls-6{stroke:#b8d8c7;}.cls-11,.cls-14,.cls-15,.cls-18,.cls-20,.cls-21,.cls-22,.cls-23,.cls-27,.cls-29,.cls-4,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-14,.cls-15,.cls-18,.cls-20,.cls-23,.cls-27,.cls-29,.cls-4{stroke-width:1.8px;}.cls-5{fill:#b8d8c7;}.cls-6{stroke-width:1.8px;}.cls-7{fill:#b0d7c0;}.cls-8{fill:#22272e;}.cls-9{fill:#f4c2c9;}.cls-10{fill:#6dafa7;}.cls-11,.cls-21,.cls-22{stroke:#22272e;}.cls-12{fill:#ffe779;}.cls-13{fill:#b28d93;}.cls-14{stroke:#896068;}.cls-15{stroke:#63737a;}.cls-16{fill:#896068;}.cls-17{fill:#63737a;}.cls-18{stroke:#fff;}.cls-19{fill:#f8ab5d;}.cls-20{stroke:#f8ab5d;}.cls-21{stroke-width:4px;}.cls-22{stroke-width:1.8px;}.cls-23{stroke:#e26e85;}.cls-24{fill:#fff;}.cls-25{fill:#e26e85;}.cls-26{fill:#e86484;}.cls-27{stroke:#6dafa7;}.cls-28{fill:#ffe7ca;}.cls-29{stroke:#ffbf94;}.cls-30{fill:#ffbf94;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M767.3,559.1l-520-14.9a48.07,48.07,0,0,1-46.5-43.3l-25.1-248a48.18,48.18,0,0,1,47.2-53l578.8-8A48.21,48.21,0,0,1,850.2,246L816.5,517A48.1,48.1,0,0,1,767.3,559.1Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M767.3,559.1l-520-14.9a48.07,48.07,0,0,1-46.5-43.3l-25.1-248a48.18,48.18,0,0,1,47.2-53l578.8-8A48.21,48.21,0,0,1,850.2,246L816.5,517A48.1,48.1,0,0,1,767.3,559.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.9,604.2H-72.6a15,15,0,0,1-15-15V353.5a15,15,0,0,1,15-15H342.9a15,15,0,0,1,15,15V589.1A15.07,15.07,0,0,1,342.9,604.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M892,588.3H472.9a15,15,0,0,1-15-15V229a15,15,0,0,1,15-15H892a15,15,0,0,1,15,15V573.3A15,15,0,0,1,892,588.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.1,338.5H207.8a4.32,4.32,0,0,1-4.3-3.8l-1.6-14.4a4.33,4.33,0,0,1,4.3-4.8h23.5a4.34,4.34,0,0,1,4.3,4.8l-1.6,14.4A4.32,4.32,0,0,1,228.1,338.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.5,315.6s-8-.8-9.6-11.6c0,0,7.2,2.1,9.5,7.2,0,0,1-11.4,6.4-12.5,0,0,2.4,8.5-1.4,12.7,0,0,2.9-4.8,10.3-4.7a13.6,13.6,0,0,1-9.2,8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.8,388.2H249.6a4.23,4.23,0,0,1-4.2-4.2V356.6a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2V384A4.23,4.23,0,0,1,339.8,388.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M305,362.1H284.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H305a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,305,362.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.8,434H249.6a4.23,4.23,0,0,1-4.2-4.2V402.4a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.23,4.23,0,0,1,339.8,434Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M305,407.9H284.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H305a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,305,407.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M802.9,466.4H712.7a4.23,4.23,0,0,1-4.2-4.2V434.8a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.1,4.1,0,0,1,802.9,466.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M768.2,440.2H747.4a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,768.2,440.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M687.1,466.4H596.9a4.23,4.23,0,0,1-4.2-4.2V434.8a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.1,4.1,0,0,1,687.1,466.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M652.4,440.2H631.6a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5h20.8a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,652.4,440.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.8,388.2H134.6a4.23,4.23,0,0,1-4.2-4.2V356.6a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2V384A4.23,4.23,0,0,1,224.8,388.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190,362.1H169.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H190a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,190,362.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.8,434H134.6a4.23,4.23,0,0,1-4.2-4.2V402.4a4.23,4.23,0,0,1,4.2-4.2h90.2a4.23,4.23,0,0,1,4.2,4.2v27.4A4.23,4.23,0,0,1,224.8,434Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M190,407.9H169.2a1.54,1.54,0,0,1-1.5-1.5h0a1.54,1.54,0,0,1,1.5-1.5H190a1.54,1.54,0,0,1,1.5,1.5h0A1.47,1.47,0,0,1,190,407.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M934.3,318.9h-455a4.65,4.65,0,0,1-4.6-4.6V234.6a4.65,4.65,0,0,1,4.6-4.6h455a4.65,4.65,0,0,1,4.6,4.6v79.7A4.65,4.65,0,0,1,934.3,318.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M934.3,417.8h-455a4.65,4.65,0,0,1-4.6-4.6V333.5a4.65,4.65,0,0,1,4.6-4.6h455a4.65,4.65,0,0,1,4.6,4.6v79.7A4.65,4.65,0,0,1,934.3,417.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 505.3,
    y: 268.6,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 515.1,
    y: 282.3,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 803.7,
    y: 367.4,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 813.5,
    y: 381.1,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 783.5,
    y: 367.4,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 746.19,
    y: 386.8,
    width: 50.3,
    height: 9.9,
    transform: "translate(165.52 1009.34) rotate(-72.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 793.4,
    y: 381.1,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 670.1,
    y: 268.6,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 680,
    y: 282.3,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 572.4,
    y: 268.6,
    width: 9.9,
    height: 50.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 535.11,
    y: 287.92,
    width: 50.3,
    height: 9.9,
    transform: "translate(112.29 738.95) rotate(-72.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 582.2,
    y: 282.3,
    width: 10.3,
    height: 36.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M813.4,275.1l1.1-14.9a1.65,1.65,0,0,0-1.7-1.8h-8.6a1.71,1.71,0,0,0-1.7,1.8l1.1,14.9s-9,5.8-8.9,10.6c.1,3.7,2.3,21.4,3.3,29.2a4.32,4.32,0,0,0,4.3,3.8h12.4a4.32,4.32,0,0,0,4.3-3.8c1-7.8,3.2-25.5,3.3-29.2C822.4,280.9,813.4,275.1,813.4,275.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M773.6,275.1l1.1-14.9a1.65,1.65,0,0,0-1.7-1.8h-8.6a1.71,1.71,0,0,0-1.7,1.8l1.1,14.9s-9,5.8-8.9,10.6c.1,3.7,2.3,21.4,3.3,29.2a4.32,4.32,0,0,0,4.3,3.8h12.4a4.32,4.32,0,0,0,4.3-3.8c1-7.8,3.2-25.5,3.3-29.2C782.6,280.9,773.6,275.1,773.6,275.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 174.3,
    y1: 512.2,
    x2: 1130.1,
    y2: 512.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M274.5,426.1,261.8,603.7a2.63,2.63,0,0,0,2.6,2.8h0a2.54,2.54,0,0,0,2.6-2.4l15.3-178Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M788.6,426.1l12.7,177.6a2.63,2.63,0,0,1-2.6,2.8h0a2.54,2.54,0,0,1-2.6-2.4l-15.3-178Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M385.7,206.3s8.9,18.1,15.3,34.4,7.5,31.4,1.3,34.6c-8.7,4.5-18.4,4.8-29.6-16.4S369.9,189.8,385.7,206.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M337.8,536.9c.1,1.2-3.5,21.5-3.3,23s-15.3,5.4-22.8-1.3c0,0,1.1-26.5,1.1-30.5S337.1,525.7,337.8,536.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M334.8,556.3s1.7,7.5,4.2,12.1,16.3,17.5,14.8,21.9-14.2,4.8-24,4.4-14.2-3.8-18.1-10.8-1.3-11.7-.8-25.3c0,0,.3-2.3.9-2.7,0,0,2,3.5,4.3,3.8s4.6-5.3,10.2-5.9,6.3,5,6.9,5S334.6,557.9,334.8,556.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.9,577.8s-7-3-20,1.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.4,572.3s-7-3-20,1.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M387.8,533.4c.1,1.2-3.5,21.5-3.3,23s-15.3,5.4-22.8-1.3c0,0,1.1-26.5,1.1-30.5S387.2,522.2,387.8,533.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M384.9,552.7s1.7,7.5,4.2,12.1,16.3,17.5,14.8,21.9-14.2,4.8-24,4.4-14.2-3.8-18.1-10.8-1.3-11.7-.8-25.3c0,0,.3-2.3.9-2.7,0,0,2,3.5,4.3,3.8s4.6-5.3,10.2-5.9,6.3,5,6.9,5S384.7,554.4,384.9,552.7Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.9,574.3s-7-3-20,1.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M391.5,568.8s-7-3-20,1.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M293.1,317.6s-3,17.5,5.6,58.6c2.6,12.5,4.7,28.8,6.2,45.9,3.5,39,.5,78.8-1.3,94.5-2.6,22.5,8.9,26.8,21.3,27.8s17-4.7,17.6-11,8-90.3,10.8-109.3,3.1-45,2.2-48.8,9.9-3,5.4-50C356.5,278.1,296.7,305.1,293.1,317.6Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M379.2,319.9s15,64.2,16.8,84.2-1.9,118.1-1.8,124-5.3,11.2-18.7,11.5-18.8-8.6-18.7-13.4c.3-16,.5-79.7-.5-89.5s-15.6-58-18.5-62.6-9.3-39.2,3.3-45.2S373.5,313.9,379.2,319.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M360.3,191.8s-25.6-.9-37.5-2.5-34.1-1.7-42.9,16.2,18.5,26.7,17.8,39.4-2.5,34.2-2.5,34.2-2.5,24.1-5.3,33.2,2.5,13.7,5,14.5,28.5,6.1,48.2,5,35.8-5.6,37.2-10-.9-17.3,0-30.8,3.5-37.1,3.5-46.1,4.4-31.8,0-41.2S368.8,192.1,360.3,191.8Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M326.7,181.2s-4.1.6-5.5,3.3a17.12,17.12,0,0,0-1.9,8c.1,3.2,4.9,12,18.8,13.6s18.9-5.2,19.5-7.8-.4-9.6-1.4-10.8-2.4-2.6-7.4-3.2C343.9,183.5,328.3,180.6,326.7,181.2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M346.8,242a68.73,68.73,0,0,0,6.2-7.5c2.1-3.2,4.9-6.7,7.2-8s7.1-2.2,8.4-2.9,2.8,1.8,0,4.1-1.6,9-5.5,12.6S348.2,246.1,346.8,242Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M375.9,182.8l50.5-3.3a2.37,2.37,0,0,1,2.5,2.7l-12.4,76.2a3.82,3.82,0,0,1-3.3,3.2l-48.3,6.6a2.44,2.44,0,0,1-2.7-2.6l10.2-79.4A3.6,3.6,0,0,1,375.9,182.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M411.6,183l-19.1,1a1.18,1.18,0,0,1-1.2-1.3l.3-2a1.6,1.6,0,0,1,1.5-1.4l19.1-1a1.18,1.18,0,0,1,1.2,1.3l-.3,2A1.7,1.7,0,0,1,411.6,183Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M300.2,260.2s6.3-25.3,7.9-35-4.5-20.5-13.9-22.9c-11-2.7-14.4,3.1-14.4,3.1s-4.4,7.7-8.8,31.9-6.9,46.7,8.8,52.2,47.9-12.4,58.2-20.1,14.1-10.9,16.1-11.4,9.9,1.6,14.1-3.1,7.8-8.4,8.2-8.4,10.4,1.5,12.1.2c1.9-1.5-.9-3-2.9-3.3s-7.7-2.2-7.7-2.2,4.5-1.4,7.7-2.6,6.5-1.9,6.3-3.6-2.2-1.5-4.2-1.6a21.66,21.66,0,0,0-4.7.5s5.5-1.5,6.9-3.1.2-3-2.7-2.7a44,44,0,0,0-5.5,1s5.6-.5,5.2-3c-.3-1.7-5.3-.8-8.6-.4a97.69,97.69,0,0,0-11.1,2.1,36.32,36.32,0,0,0-6.1,2c-3.5,1.7-12.3,10.1-13.7,11.8s-19,4.5-33.4,7.7-22.8,5.8-27.2,9.9Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M378.5,225.6a97.69,97.69,0,0,0-11.1,2.1,36.32,36.32,0,0,0-6.1,2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.4,260.2c-2.5,1.8-6.3,4.8-12.3,9.2-10.3,7.6-42.5,25.5-58.2,20.1s-13.1-28-8.8-52.2,8.8-31.9,8.8-31.9,3.4-5.8,14.4-3.1c9.3,2.3,15.5,13.1,13.9,22.9-1,6.1-3.9,18.5-5.9,26.8,3.5-1,7.5-1.9,12.1-2.9,10.2-2.2,22.1-4.3,28.6-5.9a16.94,16.94,0,0,0,1.1,10.8C346.4,259.2,350.4,260.2,350.4,260.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M270.1,280s-.2-5.4,6.4-4.7,23.7,6.9,18.8,14.2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M335,245a19.26,19.26,0,0,0,1.2,11.7,20.74,20.74,0,0,0,7.6,8.6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M325.9,165.5s-.3,12.8-1.1,20.8,14.1,11.3,21.3,9.9,8.3-3.6,8.3-3.6-.6-10.8,0-14.7S326,161.3,325.9,165.5Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M354.2,189.7c-.1-1.6-.1-3.7-.1-5.8-6.1.3-11.5-5.3-15.9-9.9C337,183.6,345.3,189.8,354.2,189.7Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M366,148.5s5-2.6,6.5-10.8-.3-20.4-5.9-21.8-1.7,15.8-5.5,19S366,144,366,148.5Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M365.8,134.4a62.57,62.57,0,0,1,1.1,17c-.6,10.2,1.4,27.4-9.7,32.4s-25.8-.2-31.8-16.6-6.1-32.7,3.1-39.7S362.5,121.4,365.8,134.4Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M326.6,154.1s3.4-1.1,3.5-7.2,3.3-11.3,9.9-9.5,15.8,6.9,21.2,6.8c6.4-.2,8.4-7.1,8.9-15.6s-2.3-13.8-5.6-12.9-6.1,3.7-10.2-1.5c-5.6-7-10.6-6.8-14.6-3.5-7,5.9-5.4,9-11.8,6.5-3.7-1.5-6.3-1.1-8.1,5.8s-1.1,8.8-5.4,8.2-1.6,22.2,5.4,27.3C319.9,158.5,325.3,153.6,326.6,154.1Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M361,155.8c.4,1.1.6,2.2.9,3.2s.6,2.1.9,2.9a5.3,5.3,0,0,1,.5,1.9,2.81,2.81,0,0,1-.6,2,3.82,3.82,0,0,1-3.4,1.3,5.44,5.44,0,0,0,2.2-2,2.73,2.73,0,0,0-.4-2.4,8.75,8.75,0,0,1-.7-3.5A18.57,18.57,0,0,1,361,155.8Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M351.3,147.1a1.2,1.2,0,0,0,1.3-1.6c-.3-.9-.5-1.7-1.5-1.9a13.24,13.24,0,0,0-9.3,1.9c-2.7,2-.1,2.4,3.3,1.7A21.74,21.74,0,0,1,351.3,147.1Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 346.7,
    cy: 156.9,
    rx: 9.9,
    ry: 10.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 367.4,
    cy: 156.9,
    rx: 6.4,
    ry: 9.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M361.2,154.8s-1.3-1.8-4.8,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 337.2,
    y1: 154,
    x2: 325.3,
    y2: 153.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M352.7,174.2a8.87,8.87,0,0,1-6.8-4.7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M348.2,160.7h0a1.68,1.68,0,0,0,1.8-1.6l.1-1a1.68,1.68,0,0,0-1.6-1.8h0a1.68,1.68,0,0,0-1.8,1.6l-.1,1A1.63,1.63,0,0,0,348.2,160.7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M363,161h0a1.68,1.68,0,0,0,1.8-1.6l.1-1a1.68,1.68,0,0,0-1.6-1.8h0a1.68,1.68,0,0,0-1.8,1.6l-.1,1A1.83,1.83,0,0,0,363,161Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M326.2,154.4s-2.9-5-6.8-3.7-3.8,7.3-1.9,10.9a11,11,0,0,0,10.8,5.5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M319.3,158a2.85,2.85,0,0,1-.2-1.6,1.8,1.8,0,0,1,.4-.9,1.61,1.61,0,0,1,1.1-.5,2.34,2.34,0,0,1,1.8.8,7.1,7.1,0,0,1,1,1.4,17.15,17.15,0,0,1,1,2.6,3.6,3.6,0,0,0,.5.9c.2.2.7.2,1.2.2a1.58,1.58,0,0,1-1.5.7,3.31,3.31,0,0,1-1.5-1,21.75,21.75,0,0,1-1.4-2.5c-.4-.8-.8-1.4-1.2-1.5-.1,0-.2-.1-.3,0s-.2.1-.3.3S319.5,157.5,319.3,158Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M378.5,241.3a22.3,22.3,0,0,0-3.3-.6,7.82,7.82,0,0,0-2.4,0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M383.1,233.8s-10.2,2.2-11.1,2.9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M381.9,229s-7,1.5-7.4,1.6c-1.3.4-3.7,1.1-3.7,1.1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M302.3,358.7s11.7-5,11.7-22"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M190.1,497.9l-5.8,120.4a2.34,2.34,0,0,0,2.4,2.5h0a2.4,2.4,0,0,0,2.4-2.2l10.1-120.8h-9.1Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M247.2,497.9,253,618.3a2.34,2.34,0,0,1-2.4,2.5h0a2.4,2.4,0,0,1-2.4-2.2L238.1,497.8h9.1Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M229.1,474.2,229,594.7a2.39,2.39,0,0,1-2.5,2.4h0a2.56,2.56,0,0,1-2.3-2.3L220,473.7Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M251.2,486.2a251.12,251.12,0,0,0-34-2.1,252.22,252.22,0,0,0-34,2.1H164.4V493c0,4.9,23.6,8.9,52.8,8.9s52.8-4,52.8-8.9v-6.8Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 217.2,
    cy: 486.2,
    rx: 52.8,
    ry: 8.9
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M254.9,580.2s-1.3,9.6-3.1,12.5-4.8,10.1-4.7,11.8c.3,3.1,9.9,11,15.5,15.8s10.2,5,20.6,5.8,14.6-.8,14.6-4-2.1-4.7-6.7-10-11.8-12.8-14.2-17.1,2.4-10.8,4.6-14.8S259.5,568.9,254.9,580.2Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M281.5,580.2c-2.1,4-6.9,10.5-4.6,14.8.2.4.5.8.7,1.2a8.31,8.31,0,0,0-6.8-3.4c-4.8,0-7.4,5.6-11.1,2.9-2.4-1.8-5.5-3.8-7.3-4.9a67.07,67.07,0,0,0,2.3-10.7C259.5,568.9,283.7,576.2,281.5,580.2Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M251.3,416.9s4.2,10.2,6.3,13.1,53.6,7.9,59.1,28.8-27.1,109.1-30.6,117.4-4,15.6-15.8,14.4-21.3-8.8-19-17.1,11.3-30.4,15-56.9,17.1-32.1-6.9-40.2-43.1-5.5-36.5-27.9S246.7,414.5,251.3,416.9Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.5,594.8s4.2,15,4.2,16.6-2.7,14.5-2.1,18.3,5.8,5.9,12.7,12.2c7.4,6.9,13.4,6.5,22.5,5.8,7.8-.6,18.2-4.4,19.3-7.5s-.1-5.3-6.3-8.6c-5.5-3-19.3-18.3-20-20s-4.9-24-5.1-26.1S286,589.1,288.5,594.8Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M318.1,609.5c-2.1-2.6-5.1-4.8-9.1-2.4-4.2,2.5-4.6,7.9-6.8,8.2s-2.4-2.8-5.3-3.7a10.74,10.74,0,0,1-4.7-2.8c-1.1-4.7-3.7-14.1-3.7-14.1-2.5-5.7,25-11.5,25.1-9.3C313.8,587.3,316.8,603.5,318.1,609.5Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M324.8,620.4s-5.2-2-15.4,3.1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M332,626.8s-7.7-2-17.9,3.1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M180.9,415.3s-4.8,12.6-7.7,20.5-6.6,24.1,1.7,37.2,24.3,15.4,50,18.6c25.4,3.1,30.9,5.1,30.9,5.1A455.31,455.31,0,0,0,271,548c9.4,25.4,12.9,40.2,13.3,43.8s2.3,7.1,8.6,8.6,22.7-2.1,23.8-9.4-6-29.6-10.6-59.2-6.7-54.4-15.4-65.9-43-12.7-43-16S197.6,407.3,180.9,415.3Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M306,531.8c-4.6-29.6-6.7-54.4-15.4-65.9s-41.3-14.7-43-16a36.12,36.12,0,0,0-19.1-5.4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M247.6,449.9s.8-5.2,0-7.6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M174.9,453.8s16.7-.3,20.4-18.5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M255.7,496.7a11,11,0,0,1,3.8-8.1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M290.1,610.8s-2.1-5.7-18.9-1.1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M281.7,601.8s-1.6-4.2-15,1.5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M688.8,235.3l-134.6-5.5c-2.9-.1-4.9-2.8-4.5-6.1l11-80.9a7,7,0,0,1,6.1-6l134.6-5.5a5.42,5.42,0,0,1,5.9,6.2l-11,91.3A7.31,7.31,0,0,1,688.8,235.3Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M686.5,233.6l-134.6-5.5c-2.9-.1-4.9-2.8-4.5-6.1l11-80.9a7,7,0,0,1,6.1-6l134.6-5.5a5.42,5.42,0,0,1,5.9,6.2l-11,91.3A7.38,7.38,0,0,1,686.5,233.6Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 579.6,
    y1: 181.4,
    x2: 615.2,
    y2: 181.4
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M611.4,210.7l-19.2-.5a4.88,4.88,0,0,1-4.6-5.8l6.1-45.9a6.7,6.7,0,0,1,6.1-5.8l19.2-.5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M640,157.5l-22.3.4a2,2,0,0,1-2-2.3l.9-6.7a2.77,2.77,0,0,1,2.6-2.4l22.3-.7a2.05,2.05,0,0,1,2.1,2.3l-.9,6.8A2.88,2.88,0,0,1,640,157.5Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M678.4,187.4l-23.9-.1a2.12,2.12,0,0,1-2.1-2.5l.9-7a2.87,2.87,0,0,1,2.7-2.5l23.9-.1a2.14,2.14,0,0,1,2.2,2.5l-.9,7.1A2.82,2.82,0,0,1,678.4,187.4Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M632.5,217.1l-22.3-.6a2.06,2.06,0,0,1-2-2.4l.9-6.8a2.59,2.59,0,0,1,2.6-2.3l22.3.4a2.17,2.17,0,0,1,2.1,2.5l-.9,6.9A2.78,2.78,0,0,1,632.5,217.1Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 639.4,
    y1: 181.3,
    x2: 652.9,
    y2: 181.3
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M636.3,187.2l-22.3-.1a2.06,2.06,0,0,1-2-2.4l.9-6.7a2.77,2.77,0,0,1,2.6-2.4l22.3-.1a2.13,2.13,0,0,1,2.1,2.4l-.9,6.9A2.87,2.87,0,0,1,636.3,187.2Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M579.6,181.4c.5-3.7-1.9-6.6-5.3-6.6s-6.5,3-7,6.6,1.8,6.6,5.2,6.6A7.56,7.56,0,0,0,579.6,181.4Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M675.6,478.6v6.8c0,4.4-22.1,8-49.5,8s-49.5-3.6-49.5-8v-6.8h23.3a286.62,286.62,0,0,1,52.4,0Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 626.1,
    cy: 478.6,
    rx: 49.5,
    ry: 8
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M626.1,567.4h0a2.26,2.26,0,0,1-2.3-2.3V486.7h4.7v78.4A2.35,2.35,0,0,1,626.1,567.4Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M626.1,564.9s-27.2,2-35.8,20.1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M662,585c-8.7-18.1-35.8-20.1-35.8-20.1s-4.5,3.5-6.4,24.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 619.69,
    cy: 591.34,
    r: 7.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 661.95,
    cy: 586.48,
    r: 7.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 590.29,
    cy: 586.44,
    r: 7.3
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M653.1,404.9c4.8,11.5,13.3,30,13.2,50.8,0,25.2-30.5,35.5-33.6,39.5s-66.6,8.4-73.1-4.3-6.1-26.1,11.3-58.2c11.6-21.5,10.1-27.5,10.2-27.8,0,0,1.6,1.7,2.3-5S650.2,398.1,653.1,404.9Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M574.7,464.8c-6.2,1-16.6,4.3-17.7,20.8s12.1,80.5,12.3,91.8-.9,11.8-8.6,18.7-23,14.4-21.7,19.7,18.8,9.8,30.3,7.7,14.1-15.2,16.3-16.3,3.6-5.2,3.9-7.8,8.4-94.4,9.2-107.9C599.8,474.8,592.9,461.9,574.7,464.8Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M590.3,591.6c-.4,4.4-.7,7.2-.7,7.7-.3,2.7-1.7,6.7-3.9,7.8s-4.7,14.2-16.3,16.3-29.1-2.4-30.3-7.7c-1-4.1,8.1-9.6,15.8-15.1-.2.2-2.4,2.4,0,2.9s7-1.4,15.6,3.4,11.1-2.7,12.8-7.8C584.8,594.8,587.8,596.2,590.3,591.6Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M604.9,467.8c-7.5,5-10.5,11.1-11.9,34.1-1.9,31.6-5.3,81.3-6.9,86.6s-3.6,7.7-5.5,13-18,20.6-17,26.4,10.2,11.6,16,13.5,12.7,2.7,16.9,0,6.3-19.6,7.4-23.6,2.3-7,3.3-14.1,8.3-39.1,11.4-48.3,17-53.9,17.4-71.4C636.2,466.5,615.9,460.6,604.9,467.8Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M604.9,467.8c-7.5,5-10.5,11.1-11.9,34.1-1.9,31.6-5.3,81.3-6.9,86.6s-3.6,7.7-5.5,13"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M608.3,597.4a56.22,56.22,0,0,0-1.1,6.3c-.9,7-2.2,10-3.3,14.1s-3.1,21-7.3,23.6-11.1,1.9-16.9,0-15-7.7-16-13.4c-.7-4.2,7.5-13.3,12.8-20.1-.3.4-4.1,6.1,2.7,11.1,5.9,4.4,16.9,7.1,19.7.5s4.3-12.8,5.6-14.8A22.53,22.53,0,0,0,608.3,597.4Z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 583.18,
    cy: 620.61,
    rx: 4.1,
    ry: 5.5,
    transform: "translate(-200.45 954.05) rotate(-69.83)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M566.1,605.5c-.3,2.1-2.9,3.4-5.7,3s-4.9-2.5-4.6-4.6,2.9-3.4,5.7-3S566.4,603.4,566.1,605.5Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M583.5,321.3s-13.6.2-22.8,20.5-23.8,48.9-21.7,61,30,0,43.2-22.7S594.1,321.9,583.5,321.3Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M594,280.9s-6.9-.4-9.1-9.3,6.9-20,15.3-22.7,10.5,2.5,16,3.1,20.2-1,26.1,12.1-3.9,25.5,3.6,35.3,13.8,28-8.3,35.8-47.5,1.7-55.4-12.4,7.3-22.4,9.6-29.7C594.3,285.9,595.4,284.1,594,280.9Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M616.4,316.1s-20.4-.2-31.5,4c-3.3,1.2-6.1,3.3-6.9,13.7-.7,9.4-1.2,9.3-3.8,13.9-4.1,7.4-5.8,15.9,2.1,29.7,5.1,9,3.5,25.9,2.7,34.4s.2,12.3,16.7,16.5,51.9,0,55.9-4,5.8-43.6,5-51.3,14-28.2,12.9-36.3S658.8,317.5,616.4,316.1Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M605.2,314.4s-9.2.4-12.2,3.5c-2.1,2.2-.4,3.6,2.1,5.5,1.7,1.3-4.3,4.7-1.2,8.6,2.3,2.9,7.5-.7,9.5,2,2.3,3.2,2.7,4.4,6.2,4.5,4.4.1,4.8-4.6,8.1-4.1,4,.6,4.9,2,7.8,1.7,4.5-.5,4.6-5,4-7.7s1-2.8,4.5-3.8,4.2-7.8-8.7-9.7S605.2,314.4,605.2,314.4Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M628,296.3a106.66,106.66,0,0,0-1.9,20.9,15.21,15.21,0,0,1-15.5,9.8c-11.2-.6-8.6-9.6-8.6-9.6s2.7-10,2.8-12.6S625.2,293.6,628,296.3Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M619.1,307.7c-4.8,3.2-10.4,5.1-15.7,4.7l-1.3,5s-.1.5-.2,1.3C609.7,318.5,616.7,315,619.1,307.7Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M592.7,270.9a93.48,93.48,0,0,1-1.1,16.6c-1.4,8.6.1,22.2,9.4,25.4,12.9,4.4,26.3-4.4,29.6-17.2s5-28.5-11.4-33.2S593.6,264.6,592.7,270.9Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M592.2,274.5s-.7-3.1,2.2-3.7a41.52,41.52,0,0,0,8.3-3.1c1.9-.9,4.3-.6,6.2,3.6,4.2,9,9.5,22.5,20.5,18.7,0,0,4.2.9,5.4-6.1s.7-16.4-11.5-22.1-26.2-1.8-28.8,1.1C590.5,267.4,592.2,274.5,592.2,274.5Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M624.7,291.4s4.5-6.2,8.7-2.6-1.6,12.7-7.4,12.4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M631.2,301.9c0-1.4-1.2-4-2.6-4s-2.6,2.6-2.6,4a2.65,2.65,0,0,0,2.6,2.6A2.58,2.58,0,0,0,631.2,301.9Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M631.9,293c-.4-.2-.7-.5-1-.6a.58.58,0,0,0-.7,0c-.1,0-.1.1-.2.2s-.2.2-.2.3a6.37,6.37,0,0,0-.2.7c-.1.6,0,1.4-.2,2.3a2,2,0,0,1-.9,1.3,1.7,1.7,0,0,1-1.4,0c.4-.2.7-.4.8-.7a2,2,0,0,0,.1-.8,15.52,15.52,0,0,1-.1-2.3,2.4,2.4,0,0,1,.6-1.5l.6-.6a3.18,3.18,0,0,1,.9-.3,1.55,1.55,0,0,1,1.4.8A1.58,1.58,0,0,1,631.9,293Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M596.1,286.9a4.76,4.76,0,0,1,.2,2.9,5.67,5.67,0,0,1-1.3,2.7c-.2.3-.3.3-.3.6a2.3,2.3,0,0,0,.3.9,6.07,6.07,0,0,0,.7,1c.3.3.6.7,1,.8a2,2,0,0,1-1.5-.1,5.67,5.67,0,0,1-1.3-.8,2.72,2.72,0,0,1-.8-1.6v-.5a4.33,4.33,0,0,1,.1-.5c.1-.2.1-.3.2-.5s.2-.3.3-.4A15.9,15.9,0,0,0,596.1,286.9Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M600.6,301.1a9,9,0,0,0,6.4-1.8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M604.9,279.3a2.47,2.47,0,0,1,.4-1.9c.8-1,3.4-1.1,5.4.2s2.8,3.1,2.2,3.3c-.9.3-1.8-.9-3.9-1.1S605.3,280.4,604.9,279.3Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M594.6,279a.78.78,0,0,0,1-.7,3.29,3.29,0,0,0-.2-2c-.6-.9-2.2.1-2.7.8s-.3,1.9,0,1.9A5.72,5.72,0,0,1,594.6,279Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M606.9,288.7h0a1.37,1.37,0,0,0,1.5-1.3l.1-.8a1.37,1.37,0,0,0-1.3-1.5h0a1.37,1.37,0,0,0-1.5,1.3l-.1.8A1.37,1.37,0,0,0,606.9,288.7Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M594,287.7h0a1.37,1.37,0,0,0,1.5-1.3l.1-.8a1.37,1.37,0,0,0-1.3-1.5h0a1.37,1.37,0,0,0-1.5,1.3l-.1.8A1.51,1.51,0,0,0,594,287.7Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M457.4,443.4,463.2,579a2.54,2.54,0,0,1-2.4,2.8h0a2.6,2.6,0,0,1-2.4-2.5l-10.1-136h9.1Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M469.9,427.5l5.5,129a2.44,2.44,0,0,1-2.3,2.7h0a2.39,2.39,0,0,1-2.3-2.3l-9.6-129.4Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M366.5,443.5,348.3,578a2.58,2.58,0,0,0,2.1,3h0a2.57,2.57,0,0,0,2.6-2.2l22.5-134.5Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M487.9,299.6s5.9,2.7.8,26.4-14.5,55.1-13.2,90.6-22,50.2-60.1,47.5,21.7-110.3,21.7-110.3S480,289.9,487.9,299.6Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M385.7,306.8c1-4.4,3.1-11.5,11-14.4s90.9-1.5,92,8.8-20.6,58.3-20.5,92.7,6.2,62.9-34.3,68.6S350,459.8,354.4,446s17.8-32.3,21.9-70.2S382,323.8,385.7,306.8Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M366.9,416.9s-30.5,38.2-31.4,50.9,50.1,12.2,50.2,9.6,8.6-17.4,12.6-17.7c2.6-.2,6.6-.4,7.3,2.8,1,4.5,0,13.9,0,13.9L449.5,497l4.3-18.3s7.4-11.9,7.4-31.5-5.7-48.5-5.7-48.5S371.9,407.5,366.9,416.9Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M402.9,601.1s-2.7,1.8-3.3,6.3-3,11.2-4.6,16.7-6.3,16.2-3.9,18c3.4,2.7,12.4,4.6,22.8,5.5s15.4.3,17-2.7-1.8-20.2-2.4-26.7,0-13.3-1.2-15.6S407.7,594.9,402.9,601.1Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M366,595.3a26.11,26.11,0,0,0-2.4,5.9c-1.2,3.9-11.8,20.3-11.7,25.5s10.2,5.3,14.1,5.5c4.7.2,16.6-.7,20.5-3.4s4-12,4.3-15c.6-6,.5-9.6-.9-18.6-.4-2.9-4.8-3.7-7.2-2S367.8,591.4,366,595.3Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M404.5,589.2s-1.8,13.1-2,14.7,2.7,5.1,11.1,6.9c7.2,1.6,11.5-1.1,12.2-2.1s4-17.7,5.1-21.5S406.8,584.7,404.5,589.2Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M363.6,586.4s2.7,9.2,2.7,10.4,4.6,3.7,11,3.5,11.8-3.7,11.8-5.4-1.9-18-1.9-18S364.2,581.8,363.6,586.4Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M400.8,624.4a26.41,26.41,0,0,1,23.9,5.5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M404,617.1s12.1-2.2,19.8,4.1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M403,606.4a4.62,4.62,0,0,0,4.3,0c2.3-1.2,4.7-3.4,9.4-2.5,5.7,1.1,6.8,7,9.9,4.4,0,0,.1,4-7.7,4.4S403.1,607.7,403,606.4Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M365.9,597s1.1,1.2,2.9-.5,1.6-3.6,6.5-4.3c3.2-.4,5.9,1.9,8.3,3.8s4.8-.7,5.3-2.9c0,0,1.6,5.7-.6,8.5-1.6,2.1-7.8.6-11.5.7s-11.7-1.7-11.7-1.7Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M359.1,611.7s9.4-5.8,22.3,2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M363.6,605.7s8.2-5.8,19.5,2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M417.4,456.7s-12.1,1.7-12.9,31.9-3.3,78.7-6.7,85.5-2.2,14.8,4.1,18,13.6,6.9,22.8,5.9,13.6-6.3,13.6-17,3.9-40.7,9.9-65.1,10-48.5-2.2-57.2S417.4,456.7,417.4,456.7Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M345.7,454.3s-18.2,2.3-7.9,47.4,17.2,68.8,15.6,75.7,3.4,10.6,9.1,11.9,16.6,1.1,22.8-2.4,6.9-9.1,4.4-19.8-3.1-53.5-3.4-68.2,3.4-39.7-14.4-46.9S345.7,454.3,345.7,454.3Z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 357.1,
    cy: 469.8,
    rx: 14.5,
    ry: 14.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 428.8,
    cy: 480.8,
    rx: 14.5,
    ry: 14.3
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M462.2,267.8s5.9-1.9,7.8-6.2,1.7-17.3-1.8-21.4-13.3-2.3-19.5-4.1-10.5-5.8-22-3.6-22.1,12.5-22.6,18.1,2.8,7.9,1.6,11.5-2.8,7.1,2.8,12.6,3.4,9.1,7.6,9.1-3.4-12.8,2-23.8S459.2,255.4,462.2,267.8Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M346,334s-13.2,17.4-15.5,30.5,4.8,21.6,13.6,23,38.3-37.1,39.7-44.9S350.2,327.9,346,334Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M388.1,300s-6.7-1.9-22.8,12c-13.5,11.6-24.2,22.7-24.2,22.7s28.4,25.8,32.3,32.5c0,0,17.5-20.2,19-40.6S390.6,299.2,388.1,300Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M346,330.1s20.5,16.5,31.6,31.7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M380.2,308.5c2.5-5.6,7.5-9.7,13.7-9.9,6-.2,15.1-.1,28.3.8,28.4,2,50.3,10.1,56.1,14.3s-1.3,30.2-7.3,44.6-12.5,27.5-13.6,32.5,2.9,28.6.8,33.4-24.4,13.1-52.8,11.5-40.2-10.8-41.1-14.2,2.7-32.9,4.4-43,2.9-32.3,3.1-35.5C373.6,322.4,377.6,314.3,380.2,308.5Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M504.2,355c-7.1-12.2-31.7,12.1-31.1,17.5,0,0,4.4,9.2,4.4,10.2s-4.4,26.3-7.4,40.5c-.9,4.4-3.6,9.3-6.9,14a153.9,153.9,0,0,0,23.8,6.9c10.6-18.5,22.8-46.8,24.7-53.8C515.2,377.2,511.3,367.2,504.2,355Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M477.5,382.7a12.69,12.69,0,0,1,6.4-6.2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M478.3,313.6s8.1,4.5,16.1,18,14.2,25.8,14.2,25.8l-35.2,18.4s-10.2-16.7-14.4-24.2-4.6-22.9,1.3-31.5C466,311.6,475.5,311.7,478.3,313.6Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M470.1,370.5S490.6,357,505.7,352"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M468.1,428.8s-14.1,1.4-17.3,3.2-8,12.7-7.6,13.7,3.4,0,3.4,0-.4,2.1,2,2.1,2.8-1,2.8-1a2.11,2.11,0,0,0,2.4,2.5c2.8-.2,8.6-5.2,8.6-5.2s-3.1,5.5-1.2,6.8,6-3.3,6.6-4.2,16.5,8.7,22.6-9C490.4,437.7,478.9,425.2,468.1,428.8Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M408.8,298s-4.8.5-5.8,1.4-4,8.7,0,16.8,15.6,12.1,27.4,8.4,16.8-15,16.4-18.5-2.5-4.6-6.8-5.7S408.8,298,408.8,298Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M414.5,272.9s.3,9.2-2,16.7a42.34,42.34,0,0,1-3.6,8.3,13.8,13.8,0,0,0-1.6,4.7c-.6,4.1-.3,11.2,7.2,14.6,12,5.4,24.6-4.5,26.3-12.4,0,0,.7-8.2,2.5-11.5S420.3,269.8,414.5,272.9Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M440,307.1a12.67,12.67,0,0,0,.8-2.3,33,33,0,0,1,.5-3.7,30.9,30.9,0,0,1-20.1-12.7C421.8,298.2,430.2,305.7,440,307.1Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339.2,385.9s4.9,5.5,26.7,0,49.9-20.7,54.1-22.2,5.8-.8,10.3-.8c10.7.2,15.1-.8,16.5-1.5,2.8-1.4,4.1-3.5,3.6-5.3s1-2.3,1.3-3.9c.5-3-.6-3.4-.3-3.6s3.3-1.1,3.9-1.9c1.5-2.3.3-3.8.3-3.8a56.06,56.06,0,0,1,8.3-1.4c4.5-.4,7.2-2,5.9-3.6s-10.1-1.1-15.8-1.1-7.7.1-8.1-.1c-2.2-.7-6.5-2-8.6-1.8s-4.5,1.9-8.6,4.1a62.06,62.06,0,0,1-14.7,5.5c-4.6,1.2-35.5,3.6-54.6,7.2-2.7.5-5.2,1-7.3,1.6a35,35,0,0,0-6.1,2.1C335.6,361,326.5,375.7,339.2,385.9Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M455.5,342.9s-2.6-.4-3.5-.6a15,15,0,0,0-2.4-.2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M451.4,348.6s-1.8.5-2.5.8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M450.4,355a29,29,0,0,1-2.7,1.4"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M420,363.7c-7.7-9.1-3.8-19.8-3.8-19.8l-8.6,1.6c-4.9,12.1,3.8,22.3,3.8,22.3Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M445.8,336.7s-5.4.1-6.3.5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M359.4,351.7c-2.7.5-5.2,1-7.3,1.6a35,35,0,0,0-6.1,2.1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M416,355a5.2,5.2,0,1,0-5.2,5.2A5.36,5.36,0,0,0,416,355Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M463.4,250.8s2.2,6.6-.9,16.4-5.2,13.5-7.8,21.3-8.9,14.6-19.6,13.5c-11.2-1.2-20-11.4-20.5-24.1s-1.6-32.5,13.5-36C443,238.5,460.8,247.4,463.4,250.8Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M453.5,272a18.84,18.84,0,0,0,.2,3.4c.1.5.2,1.1.3,1.6.1.3.1.5.2.8l.1.4.1.5a4.1,4.1,0,0,1,0,2.2,3.41,3.41,0,0,1-1.4,1.7,4.87,4.87,0,0,1-3.7.5,10.33,10.33,0,0,0,2.8-1.6,2,2,0,0,0,.5-2.3l-.1-.3-.1-.5c-.1-.3-.1-.6-.2-.9a12.1,12.1,0,0,1-.1-1.9A9,9,0,0,1,453.5,272Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M417.2,266.6s3.3-.8,5.4-9.5c0,0,.7-2,4.2.7s9.3,7.1,19.5,2.3,11.5-6.4,12.9-4.7c0,0,1.5,7.6,6.7,5.2s2.4-15.9-14.8-20.3-29.4-2.9-34.9,6.7S412.8,266,417.2,266.6Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M448.6,263.4a3,3,0,0,0,.4-3.4c-1.1-1.7-8.6-2.9-10.4-1.4s2.7,1.7,4.8,2.7S448,264.1,448.6,263.4Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M457.9,267.7a2.92,2.92,0,0,1,1.5-1.6c1.1-.5,3.4,1.8,3,3.3s-1.5-.2-2.5-.4C458.9,268.6,457.6,268.3,457.9,267.7Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M442.9,269.2a1.53,1.53,0,0,0-1-2h0a1.53,1.53,0,0,0-2,1l-.2.5,2.9,1.1Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M457.9,274.8a1.58,1.58,0,0,0-3-1l-.2.5,2.9,1.1Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M419,268.3s-1.7-6.8-6.7-6.7-7.3,13.7,4.2,15.8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M411.5,267.8a2,2,0,0,1,.5-1.4,1.27,1.27,0,0,1,.9-.4,2.39,2.39,0,0,1,.9.2c.1,0,.3.2.4.3s.2.3.3.4.1.3.2.4.1.3.1.4a6.15,6.15,0,0,1,.1,1.3v2.3a1.61,1.61,0,0,0,.3.9,2.18,2.18,0,0,0,.9.7,1.7,1.7,0,0,1-1.4,0,2.16,2.16,0,0,1-1.1-1.2,6.46,6.46,0,0,1-.5-2.7c0-.8-.1-1.7-.1-1.7a.71.71,0,0,0-.6-.3A8.18,8.18,0,0,1,411.5,267.8Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M442.6,289.6a10.62,10.62,0,0,0,1-1.7,1.58,1.58,0,0,0-.9-2.2,15.23,15.23,0,0,1-3.8-2.3c-3.1-2.5-4.5-.3-4.3,2.5C437.6,286.2,440.3,288.1,442.6,289.6Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M434.6,285.8c.2,2.4,1.5,5.3,4.1,5.7a4,4,0,0,0,3.9-1.9C440.3,288.1,437.6,286.2,434.6,285.8Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M234.9,451.4l-14.7,205a3.05,3.05,0,0,0,3,3.2h0a3,3,0,0,0,3-2.7l17.7-205.4h-9Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M828.2,451.4l14.7,205a3.05,3.05,0,0,1-3,3.2h0a3,3,0,0,1-3-2.7L819.2,451.5h9Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "859.5 447.1 203.6 447.1 278.6 416.9 784.4 416.9 859.5 447.1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 203.6,
    y: 447.1,
    width: 656,
    height: 7.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M464.4,411.9h42.1a5.5,5.5,0,0,1,3.2,1l38.2,25.5a1.52,1.52,0,0,1-.8,2.8H486.2a4.41,4.41,0,0,1-3.6-1.8l-19.4-25A1.54,1.54,0,0,1,464.4,411.9Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 490.4,
    y1: 433.3,
    x2: 529.7,
    y2: 433.3
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M518.8,425.8l-8.2-6.2a1.92,1.92,0,0,0-1.2-.4H498.7c-.4,0-.5.4-.3.7l6.2,6a2,2,0,0,0,1.4.6h12.6C519,426.5,519.1,426.1,518.8,425.8Z"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 496.6,
    y1: 426.5,
    x2: 485.8,
    y2: 426.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 493.1,
    y1: 422.4,
    x2: 483.4,
    y2: 422.4
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M707.5,445.3l-12,.9a8.2,8.2,0,0,1-3.1-.3l-54.8-15a2.91,2.91,0,0,1-2.1-2.8h0l93.2-2.3Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M694.1,441.9l23.2-61.7a5.5,5.5,0,0,1,5.3-3.6l95.2,1.8a3,3,0,0,1,2.7,4.2l-22,53.9a5.71,5.71,0,0,1-4.8,3.5l-96.6,6.1A3.23,3.23,0,0,1,694.1,441.9Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M697.5,446.1l-2,.1a8.2,8.2,0,0,1-3.1-.3l-54.8-15a3,3,0,0,1-2.1-2.8l60.1,14.4Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M774.6,409.9c-1.1,3.8-5,6.9-8.8,6.9s-6-3.1-4.9-6.9,5-6.9,8.8-6.9S775.7,406.1,774.6,409.9Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M237.6,314.5s9.8-2.7,18.4,12.7,12.9,44,15.6,46.9,7.1,5.1,21.3,14.2,15,9.4,27.3,10.9,13.1,5.7,16.9,9.9,6.5,7.1,2.9,7.4-7.5-4.9-9.8-3.4a23.55,23.55,0,0,1-8.1,3.8c-4.2,1-2.9,2.7-6.8,2.3s-11.5-.2-9.1-2.3,0-2.6,0-2.6-42.3-5.7-56-16.8-17.3-47.9-20-60.1S234.2,314.5,237.6,314.5Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M271.6,374.1a13.44,13.44,0,0,0-6.5,1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M242.4,265.8s7.4-7,4.5-16.1-11.9-10-19.2-7.8-27.3-1.5-34.6,9.6-2.7,21.1-7.3,24-11.1,5-10,12.3,20.6,17.9,14.6,26.3-11.7,27.9,11.5,39,24.6-15.4,26.1-30.8-3.1-33.2,3.5-39.8C238.2,275.7,243.7,272,242.4,265.8Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M208.6,310.9s26.5.6,31.1,2.7,6.7,9.2,8.1,14.6,11.9,11.9,13.8,23.8-8.3,25.7-8.8,27.9-.6,24.6.6,29.2,3.3,12.1,3.1,15.4-14.2,9.8-35,8.6-42.6-11.7-43.3-14,6.2-13.1,4.3-35.7-12.7-46.9-4.8-60.3C185.6,309.9,204.6,310.8,208.6,310.9Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M207.6,291.9s1.1,11.6.9,19c0,0,2.9,6.2,12,8,11,2.3,13.2-4,11.7-6.7,0,0-2.6-9.6-2.9-16.2C229.1,289.6,208.1,291,207.6,291.9Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M216.6,301.5c4.1,6.4,8.3,9,15.5,9.5-.4-1.4-.9-3.9-1.5-6.6C224.9,305.1,222.2,303.1,216.6,301.5Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M203.8,310.9a49.07,49.07,0,0,1,11.6,12c5.7,8.2,13,14.3,18.1,13.7s7.5-7.3.9-24.1C234.4,312.5,218.4,309.9,203.8,310.9Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M298.1,405.5l41.9-2.6c.5,0,1.1-1.1,1.3-.7a10.82,10.82,0,0,1,0,1.8,1.4,1.4,0,0,1-.3.9l-31.6,32.4a6.13,6.13,0,0,1-5,1.8L263.2,435a1,1,0,0,1-.9-.6,19.12,19.12,0,0,1-1.6-3.2c0-.3,2.3-.3,2.6-.5l32-24.1A5,5,0,0,1,298.1,405.5Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M297.6,402.9l42.5-1.8a1.23,1.23,0,0,1,.9,2.1l-32.7,32.2a6,6,0,0,1-5.1,1.7L261.5,432a1.22,1.22,0,0,1-.6-2.2l33.7-25.9A5.14,5.14,0,0,1,297.6,402.9Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M316.4,401s-1.1.2-1.1,2.3.8,7.7-1.3,8.1-3-2.1-4-4.3-4-2.3-5.9-5.5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M239.8,255.1a58.09,58.09,0,0,1,3.2,16.4c.3,8.8,3.3,13.8,1.6,21.4s-7.7,13.5-15.1,13.8-18.2-6.3-24.1-14.2-7.7-24.4-4.2-32.4C204.5,252.2,230.7,243.9,239.8,255.1Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.2,263.7a7.62,7.62,0,0,1-7-3.9s-6.5,15-17,16c-7.2.7-8.6-2.7-11.6,0s5.7,18.3,3,31-15.5,16.2-24.5,8.4c-11.3-9.9,1-11.8,3.3-25.8s0-24.6,7.4-32.7,14.7-13.1,26.4-12S239.8,247.6,243.2,263.7Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M212.3,273.9s-.7,5.3-.4,7-3.1-1.9-6.2.4c-1.7,1.3-3.3-6.9,0-9.4S210.8,271.5,212.3,273.9Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M210.4,281s-3.8-4.9-7.9-1.9,1.2,12.1,7.4,11.4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M294.5,428.4s5.7,4.7,7.9,6.3.8,3-1.6,3S290.5,431.4,294.5,428.4Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M181.2,319a12.48,12.48,0,0,0-5.6,5.3,35.78,35.78,0,0,0-3.3,24.7c3.7,16.9,12.4,42.3,16.3,48.3s22.2,18,35.1,26,22.8,12.4,25.2,14.2,7.2,6.4,16.3,7.5,12.1-2.2,14.9-1.5,7.5,3.9,10.1,3.6,1.2-2.3.2-3.3-6.9-6.3-6.9-6.3a77,77,0,0,1,8.8,4.6c4.4,2.6,6.5,2.7,7.7,2.6s2.6-.5,2.4-1.6a1.94,1.94,0,0,0,2.2-.2c1-.9,1.3-1.7-1.1-4.4s-8.5-9.8-11.5-12.9-6.5-3.4-13.9-3-17.8-1.2-18.1-.9-32.1-33.4-41.7-43c0,0-7.7-25.1-10-35.9C203.6,321.1,192.2,313.8,181.2,319Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M302.4,443.2s0-1.2-3-3.3-7.7-6.6-9.2-7.7a19.59,19.59,0,0,0-3.6-2.5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M283.5,437.6s-2.3-2-3.4-1.7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M218.3,378.7a11,11,0,0,0-8.4,3.3"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239.3,276.8c.7.9,1.3,1.8,1.9,2.6a5.24,5.24,0,0,0,1,1.1l.5.5.3.2c.1.1.3.2.4.4a3.32,3.32,0,0,1,.7,2.1,3.51,3.51,0,0,1-.6,1.8,4.56,4.56,0,0,1-2.7,2.2,8.19,8.19,0,0,0,1.4-2.8,2.29,2.29,0,0,0-.2-2.2c0-.1-.1-.1-.2-.2a1.38,1.38,0,0,0-.4-.3,3.74,3.74,0,0,1-.6-.7,6,6,0,0,1-.9-1.5A10.13,10.13,0,0,1,239.3,276.8Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M236.2,294.8a5.65,5.65,0,0,1-5.5-1.8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M229.4,281.4h0a1.55,1.55,0,0,0,1.3-1.9l-.2-.9a1.55,1.55,0,0,0-1.9-1.3h0a1.55,1.55,0,0,0-1.3,1.9l.2.9A1.77,1.77,0,0,0,229.4,281.4Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M241.6,279.4h0a1.55,1.55,0,0,0,1.3-1.9l-.2-.9a1.55,1.55,0,0,0-1.9-1.3h0a1.55,1.55,0,0,0-1.3,1.9l.2.9A1.68,1.68,0,0,0,241.6,279.4Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.5,271a1.4,1.4,0,0,0,1.5-1.6,4.36,4.36,0,0,0-.7-2.1c-.9-1-4.4-.7-7,1.3s-3.7,4.6-2.4,4.7,3.2-1.6,5.3-2.1A7.39,7.39,0,0,1,228.5,271Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M241.6,269.5a.65.65,0,0,1-1-.4c-.2-.8-.4-2-.1-2.3.5-.6,2-.2,2.3.7s.4,1.4.1,1.4S242.1,269.1,241.6,269.5Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M204.1,283.6a1.59,1.59,0,0,1-.1-2,2,2,0,0,1,.7-.6c.1,0,.2-.1.4-.1a1.7,1.7,0,0,1,.7.1,1.54,1.54,0,0,1,.7.7,6.72,6.72,0,0,1,.6,1.2c.3.7.4,1.4.6,1.9a1.61,1.61,0,0,0,.4.7,1.49,1.49,0,0,0,1,.3,1.66,1.66,0,0,1-1.2.5,1.71,1.71,0,0,1-1.3-.7,9.24,9.24,0,0,1-1.2-2.1,9.44,9.44,0,0,0-.3-.9c0-.1-.1-.2,0-.2h0a.55.55,0,0,0-.5.2A1.6,1.6,0,0,0,204.1,283.6Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M486.8,221.7H451.6L448,224a1.78,1.78,0,0,1-2.7-1.4V197.7a4.59,4.59,0,0,1,4.6-4.6h36.8a4.59,4.59,0,0,1,4.6,4.6v19.4A4.5,4.5,0,0,1,486.8,221.7Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M455.8,212.5l3.5-3.5a4.77,4.77,0,0,1,6.8,0,4.77,4.77,0,0,0,6.8,0l6.7-6.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "480.7 204.3 481.9 200 477.6 201.2 480.7 204.3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M795.8,337.9l-92.2-10.8a4.27,4.27,0,0,1-3.7-5.4l21.3-97.4a6.11,6.11,0,0,1,5.1-4.5l96.2-10.1a3.4,3.4,0,0,1,3.9,4.1L800.9,334.2A4.85,4.85,0,0,1,795.8,337.9Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M792.1,337.9l-93-10.9a4.33,4.33,0,0,1-3.8-5.4l21.5-98.1A5.86,5.86,0,0,1,722,219l96.9-10.2a3.4,3.4,0,0,1,3.9,4.1L797,334.3A4.58,4.58,0,0,1,792.1,337.9Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M757.8,243.8l-35,1.7a1.33,1.33,0,0,1-1.4-1.6l2.8-13a1.94,1.94,0,0,1,1.6-1.4l35.3-3a1.26,1.26,0,0,1,1.4,1.6l-3.1,14.4A1.85,1.85,0,0,1,757.8,243.8Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M711.5,316.7h0a1.21,1.21,0,0,1-1.1-1.5l5.2-24.4a1.62,1.62,0,0,1,1.7-1.3h0a1.17,1.17,0,0,1,1.1,1.5l-5.2,24.5A1.56,1.56,0,0,1,711.5,316.7Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M723.9,316.4l6.2-28.8a1.62,1.62,0,0,1,1.7-1.3h.2a1.25,1.25,0,0,1,1.2,1.5L727,316.6a1.72,1.72,0,0,1-1.8,1.3H725A1.14,1.14,0,0,1,723.9,316.4Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M737.4,317.5l7-32.9a1.93,1.93,0,0,1,1.9-1.5h0a1.34,1.34,0,0,1,1.3,1.7l-7,32.9a2,2,0,0,1-2,1.5h0A1.33,1.33,0,0,1,737.4,317.5Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M787.4,255.4l2.3,4.9c-2.8,3.2-6.2,5.2-9.4,5.2-6.2,0-9.5-7.5-7.5-16.8s8.6-17.2,14.9-17.7c3.3-.3,5.8,1.4,7.3,4.4l-4.4,5.2a4.28,4.28,0,0,0-4.3-2.7c-3.8.3-7.8,5-9.1,10.7s.8,10.2,4.6,10.1A8.73,8.73,0,0,0,787.4,255.4Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M796,247.6a29.26,29.26,0,0,1-6.2,12.6l-2.3-4.9a16.56,16.56,0,0,0,3.7-7.5,11.54,11.54,0,0,0-.5-7.3l4.4-5.2C796.6,238.4,797,242.7,796,247.6Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M760.7,303.9c-2,9.3,1.3,16.8,7.5,16.8,3.2,0,6.6-2,9.4-5.2l-2.3-4.9a8.6,8.6,0,0,1-5.6,3.2c-3.8.1-5.8-4.5-4.6-10.1a16.55,16.55,0,0,1,3.1-6.7l-2.1-4.6A28.43,28.43,0,0,0,760.7,303.9Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M774.2,293.1a4.33,4.33,0,0,1,4.3,2.7l4.4-5.2c-1.5-3-4.1-4.7-7.3-4.4-3.4.3-6.8,2.7-9.6,6.2l2.1,4.6C769.9,294.8,772,293.2,774.2,293.1Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M783.8,303a29.26,29.26,0,0,1-6.2,12.6l-2.3-4.9a16.56,16.56,0,0,0,3.7-7.5,11.54,11.54,0,0,0-.5-7.3l4.4-5.2C784.4,293.7,784.9,298.1,783.8,303Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 720.2,
    y1: 254.2,
    x2: 744.8,
    y2: 253.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 718.8,
    y1: 259.8,
    x2: 754,
    y2: 259.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 717.7,
    y1: 265.6,
    x2: 753.3,
    y2: 265.6
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M809.7,218.5c.2-.8-.1-1.4-.7-1.4a1.85,1.85,0,0,0-1.3,1.6c-.2.8.1,1.4.7,1.4A1.85,1.85,0,0,0,809.7,218.5Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M815.5,218c.2-.8-.2-1.4-.7-1.4a2.11,2.11,0,0,0-1.4,1.6c-.2.8.2,1.4.7,1.4A1.82,1.82,0,0,0,815.5,218Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M445.3,439.5v.3a1.79,1.79,0,0,1-1.8,1.8H358.7a1.79,1.79,0,0,1-1.8-1.8h0a2.84,2.84,0,0,1,.7-1.7L374,421.9a4,4,0,0,1,2.8-1.2h55.7a4.16,4.16,0,0,1,3.5,2l9,15.5A7.89,7.89,0,0,1,445.3,439.5Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M403,435.2c0,.3-.6.6-1.4.6s-1.4-.3-1.4-.6.6-.6,1.4-.6S403,434.9,403,435.2Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M740.1,528.4s-7.7-16.5,11.6-26.9,46.1-.1,43.7,3.5a118.47,118.47,0,0,1-12.7,16.5C776.6,528.2,759.1,538.6,740.1,528.4Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M792,504.3s-42.4-9.5-52,24.1-6.6,65.8-6.6,65.8"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M701.9,566.2l6.9,81.3c0,3.1,12.6,5.5,28.2,5.5s28.2-2.5,28.2-5.5l6.9-81.3Z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 737,
    cy: 566.2,
    rx: 35,
    ry: 5.3
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M728.1,549.3s-11.3-5.6-18.6,7-1.9,31.6,3.1,34.4,25.8-6.7,25.8-25.8C738.4,547.9,728.1,549.3,728.1,549.3Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M728.1,549.3s-11.3-.8-14.7,38.8"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M719.5,526.2s-11.9-18.5-35.7-6.6-23.1,44.7-19.4,46.6S723.8,548.7,719.5,526.2Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M738.4,564.9s-7.4-26-18.9-38.8S672.3,528,666,558.9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M751.7,536.6s-10.1-3.5-14.7,9c-4.5,12.2.8,40,26.8,48.4a3.6,3.6,0,0,0,3.8-1.1,43.2,43.2,0,0,0,9.9-28C777.4,544.6,766.2,529.9,751.7,536.6Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M751.7,536.6s21,10.3,13.3,53.6"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M539,402.8s.4,12.6,18.6,13.8,53.4-2.8,60.3-4.7,6.5-13,2.1-16.1-30.8-4.5-44.3-6.5c-3.1-.5-6.7-1.1-10.4-1.4a76.28,76.28,0,0,0-9.5-.4C546.7,387.9,539.1,391.4,539,402.8Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M538.8,399.3s0-2.6,3.9-1.9c8.5,1.6,15.7,19.9,7,17.6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M575.6,389.3c-3.1-.5-6.7-1.1-10.4-1.4a76.28,76.28,0,0,0-9.5-.4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M664.9,330.9c3.3,1.1,5.7,3.7,9.9,16.4,5.5,16.6,12.5,51.8,8.9,61.3s-10.8,14.4-35,15.5-47.7-.8-50.8-.8-8.3-11.4-5-18.9c0,0,20.5-5,32.1-8.1s24.4-6.4,29.7-7c0,0-8.6-21.1-11.4-28.5s-.5-20,6.1-25.7S662.1,330,664.9,330.9Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M654.6,389.3s9.9-2,15.8,0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M684.7,402.8s-2.1-5-10.6.6c-6.7,4.4-8.7,17.6-1.4,16.8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M594.9,404.6s-5.3.5-10.7.5-12.7.9-14.4,1.7-18.9,18-18.5,20.3,3.6.8,6.4-1.1,8-7.1,9.1-7.8a63.22,63.22,0,0,0-2.7,8c-1.3,4.8-2.6,9.6-1.3,10.4,1.7,1,3.3-.7,3.8-1.7,0,0-.1,2.5,1.9,2.6s3.9-3.7,5.5-6.9a59,59,0,0,1,5.1-7.4s-1.6,5.1-2.2,7.9-1,6.1.5,6.4c2.3.5,4.4-6.3,5.7-8.9s6.4-.9,10.1-3.2a27.21,27.21,0,0,1,5.8-3s2.5-2.5,2.5-7.9S597,404.4,594.9,404.6Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M566.4,435s4.8-14,6.8-16.7,2.7-2.9,3.3-3.3"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M566.6,418.3s.8-1.6,2.1-4a10.88,10.88,0,0,1,2.2-2.4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M578.9,423.2s1.4-3.4,2.8-3.8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M610.8,394.4a81.72,81.72,0,0,0,7.7-3c3.7-1.7,5.2-2.4,8.1-2.6s12-.3,13.3.5,3,4.6,3.9,6.5-2,9.4-2,9.4,1.3,6.6-.3,7.3c-1,.4-1.9.2-3.2-3.3,0,0,.9,3-.9,3.2s-3.8-5-5.1-7.3a40.85,40.85,0,0,0-3.8-5.2s1.1,3.6,1.3,4.8,1,4.3.5,5.5-2.3-.4-4.1-4.5-2.4-5.5-3.5-5.4c-6.2.6-5.8-.8-8.8-1l-6.6,1.7C607.2,400.9,606.5,396.9,610.8,394.4Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M638.3,409.1s-2-6.5-2.7-8.5a41.82,41.82,0,0,0-3-5.5"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M641.8,405.1s-1.2-7-1.7-8.7a20.62,20.62,0,0,0-1.3-3.1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M628.4,399.8s-.6-2-.9-2.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/hero-image.67c667bdede901007d7e797dbd6dbbc6.svg";
export { ForwardRef as ReactComponent };